import { confirmSignUp } from "@services/auth";
import { useMutation } from "@tanstack/react-query";

export const useConfirmSignUp = (options: any = {}) => {
  return useMutation<any, any, any>({
    mutationFn: confirmSignUp,
    ...options,
  });
};
